import { termosStep } from '../../shared/termosSections';
import { COMISSOES_OAB_MS } from '../../shared/comissoesOabMs';

const pedidoComissoesAdvogadoConfig = {
  id: 'pedido_comissoes_advogado',
  nome: 'Inscrições para Comissões OAB/MS (TIPO - ADVOGADO)',
  categoria: 'comissoes',
  descricao: 'Inscrição de advogados(as) nas Comissões da OAB/MS',
  icon: 'FaGavel',
  // Só pode enviar se não estiver inadimplente com a OAB (ver oabData.isInadimplente
  // no login) — checado em DynamicPedidoPage.js, que mostra uma mensagem explicando
  // o motivo em vez de simplesmente esconder o pedido da listagem.
  bloqueiaInadimplente: true,

  documentConfig: {
    required: []
  },

  paymentConfig: {
    amount: 0
  },

  protocoloConfig: {
    modeloRequerimento: '260',
    tiposAssunto: '754',
    departamentoDestino: '67',
    tipoPedido: '262',
    // comissaoRequerida é obrigatório pra modeloRequerimento 260 — resolvido a
    // partir da 1ª comissão marcada no multiSelect 'comissoesEscolhidas' (a API
    // só aceita 1 ID; ver protocoloResolverService.js).
    comissaoRequeridaField: 'comissoesEscolhidas'
  },

  // Confirmado ao vivo via GET /modelo-requerimento/260/campos. CLI_Comissao usa
  // a mesma comissão já resolvida como comissaoRequerida (1ª marcada no multiSelect).
  dadosRequerimentoConfig: {
    campos: [
      { field: 'nomeCompleto', campoNome: 'Nome' },
      { field: 'numeroOAB', campoNome: 'RegistroConselhoOrigem' },
      { field: 'celular', campoNome: 'TelefoneCelular' },
      { field: 'email', campoNome: 'EmailResidencial' },
      { field: 'comissoesEscolhidas', campoNome: 'CLI_Comissao', primeiro: true }
    ]
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { type: 'text', name: 'nomeCompleto', label: 'Nome completo', required: true, placeholder: 'Digite seu nome completo' },
            { type: 'text', name: 'numeroOAB', label: 'Número da OAB', required: true, placeholder: 'Nº de inscrição na OAB' },
            { type: 'phone', name: 'celular', label: 'Celular', required: true },
            { type: 'email', name: 'email', label: 'E-mail', required: true, placeholder: 'email@exemplo.com' }
          ]
        },
        {
          title: 'Comissões',
          fields: [
            {
              type: 'multiSelect',
              name: 'comissoesEscolhidas',
              label: 'Comissões que deseja participar',
              required: true,
              placeholder: 'Digite para buscar uma comissão...',
              options: COMISSOES_OAB_MS
            }
          ]
        }
      ]
    },
    termosStep()
  ]
};

export default pedidoComissoesAdvogadoConfig;
